<template>
  <div id="menu-categories-component" class="text-white fs-6">
    <div class="row ms-0">
      <div class="col-12 red-color text-center  fs-5">
        {{ languageStore.text(TEXT_KEYS.CATEGORY_TITLE) }}
      </div>
    </div>
    <div class="row ms-0">
      <div class="col-11 offset-1 border pt-2" id="categories-container">
        <ul class="ps-0">
          <li
            v-for="item in items"
            :key="item.id"
          >
            <div
              class="container-accordion"
              v-if="item.sub_categories.length > 0">
              <button
                class="border-0 bg-transparent text-white ps-0 fw-light  fs-5"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#category-' + item.id"
                :aria-controls="'category-' + item.id"
                @click="onCategoryClicked(item.id)">
                {{ item.title_fr }}
              </button>
              <ul
                :id="'category-' + item.id"
                class="accordion-collapse collapse">
                <li
                  v-for="sub_category in item.sub_categories"
                  :key="sub_category.id"
                  class="subcategories  fs-5"
                  @click="onSubCategoryClicked(item.id, sub_category.id)">
                  {{ sub_category.title_fr }}
                </li>
              </ul>
            </div>
            <div
              v-else
              class="category-no-subcategories  fs-5"
              @click="onCategoryClicked(item.id)">
              {{ item.title_fr }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

import { CategorieApi } from "@/api/categorie-api"

import { useLanguageStore } from "@/stores/language";
import { useCategoryStore } from "@/stores/category";
import { usePhotoStore } from "@/stores/photo";
import { useRouterStore } from "@/stores/router";

import { TEXT_KEYS } from "@/constants";

import categories from "@/data/categories.json"

export default class MenuCategories extends Vue {
  languageStore = useLanguageStore()
  categoryStore = useCategoryStore()
  photoStore = usePhotoStore()
  routerStore = useRouterStore()

  TEXT_KEYS = TEXT_KEYS

  items = categories

  api = new CategorieApi()

  mounted() {
    this.categoryStore.setCategories(this.items)

    this.getCategories()
  }

  async getCategories() {
    console.log("getCategories")

    try {
      const response: any = await this.api.get()
      console.log('get', response)

      this.items = response.data
      this.categoryStore.setCategories(this.items)
    } catch (error) {
      console.error(error)
    }
  }

  public onCategoryClicked(categoryId: number) {
    console.log("onCategoryClicked", categoryId)

    const current_full_path = this.$router.currentRoute.value.fullPath

    const target_path = `/photos/category/${categoryId}`
    console.log("onCategoryClicked target_path", target_path)

    if (current_full_path !== target_path) {
      this.$router.push(target_path)
    } else {
      this.routerStore.incrementReloadIndex()
    }
  }

  public onSubCategoryClicked(categoryId: number, subCategoryId: number) {
    console.log("onSubCategoryClicked", categoryId, subCategoryId)

    const current_full_path = this.$router.currentRoute.value.fullPath

    const target_path = `/photos/sub_category/${categoryId}/${subCategoryId}`

    if (current_full_path !== target_path) {
      this.$router.push(target_path)
    } else {
      this.routerStore.incrementReloadIndex()
    }
  }
}
</script>

<style lang="stylus">
#categories-container {
  border-color: #e2001a !important
}

#categories-container > ul > li {
  list-style-type: none
  text-align: left
}

.container-accordion > ul > li {
  list-style-type: none
}

.container-accordion > button:hover {
  cursor: pointer
  text-decoration: underline
  text-decoration-color: #e2001a
}

.category-no-subcategories:hover{
  cursor: pointer
  text-decoration: underline
  text-decoration-color: #e2001a
}

.subcategories:hover{
  cursor: pointer
  text-decoration: underline
  text-decoration-color: #e2001a
}
</style>